import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  stepButton: {
    textAlign: 'end',
    marginTop: '2rem',
  }
}));